import SignInForm from "@/components/Authentication/SignInForm"

export default function Login() {
  return (
    <>
      <SignInForm />
    </>
  )
}
